export default __webpack_public_path__ + "static/media/Vambraces of the Defiant.bb5e4461.jpg";